export enum RoutesE {
    HOME = '/',
    HOME_DELIVERY = '/projects/deliveryserviceindex',
    PROJECTS = '/projects',
    PROJECT_ORDER_FINISHED = '/delivery/confirmation/:projectId',
    RE_DELIVERY_CONFIRMATION = '/re-delivery/confirmation/:orderId',
    RE_DELIVERY_VERSIONS = '/re-delivery/versions/:orderId',
    RE_DELIVERY_PAYMENT = '/re-delivery/payment/:orderId',
    PROJECT_VIEW = '/projects/viewvideoad/:projectId',
    PROJECT_SHARED = '/projects/sharedvideo/:token',
    PROJECT_SHARED_AD = '/projects/sharedvideoadproject/:token',
    PROJECT_PAYMENT = '/projects/order-payment/:projectId',
    CAMPAIGN = '/projects/campaign/:campaignNumber',
    CAMPAIGN_NEW = '/campaigns/:campaignNumber',
    DELIVERIES = '/deliveries',
    DELIVERY = '/deliveries/:projectId',
    VERSIONS = '/versions',
    CAMPAIGNS = '/campaigns',
    MANAGE_CLIENTS = '/admin/clients',
    MANAGE_CLIENTS_ID = '/admin/clients/:clientId',
    MANAGE_USERS = '/admin/users',
    MANAGE_CAMPAIGNS = '/admin/campaigns',
    MANAGE_PROJECTS = '/admin/updateprojects',
    MANAGE_PROJECT_FILES_OLD = '/admin/projectfiles',
    MANAGE_PROJECT_FILES = '/admin/versions',
    MANAGE_ADVERTISERS = '/admin/advertisers',
    MANAGE_BRANDS = '/admin/brands',
    MANAGE_MARKET_CATEGORIES = '/admin/industry',
    MANAGE_PRODUCTION_COMPANIES = '/admin/suppliers',
    MANAGE_NEW_SERVICE_PACKAGES = '/admin/newservicepackages',
    MANAGE_SERVICE_PACKAGES = '/admin/clientservicepackages',
    MANAGE_FTP_SETTINGS = '/admin/clientftpsettings',
    MANAGE_MAIL_TEMPLATES = '/admin/mailtemplates',
    MANAGE_SUPPORT_MESSAGES = '/admin/support-cases',
    MANAGE_SUPPORT_MESSAGES_OLD = '/admin/supportmessages',
    MANAGE_DELIVERY_ORDERS = '/admin/delivery-service',
    MANAGE_DELIVERY_ORDERS_OLD = '/admin/deliveryservicedetails',
    MANAGE_RE_DELIVERY_ORDERS = '/admin/re-delivery-orders',
    MANAGE_SYSTEM_MAILS_OLD = '/admin/systemmails',
    MANAGE_NEWSLETTERS = '/admin/newsletters',
    MANAGE_LEADS = '/admin/contacts',
    MANAGE_LEADS_OLD = '/admin/businessPages',
    MANAGE_TRANSLATES = '/admin/translates',
    MANAGE_HOUSE_NUMBERS = '/admin/housenumbers',
    MANAGE_GLOBAL_SETTINGS = '/admin/globalsettings',
    MANAGE_VIDEO_GUIDES = '/admin/videoguides',
    SUPPORT = '/home/support',
    SUPPORT_CONTACT_US = '/home/support/contactus',
    SUPPORT_VIDEO_GUIDES = '/home/support/videoguides',
    SUPPORT_TECHNICAL_INSTRUCTION = '/home/support/technicalinstruction',
    POST_PRODUCTION_PRICE_CALC = '/home/support/pricecalc',
    HELP = '/home/help',
    REPORT_VIDEO_OLD = '/report/videoadreport', // legacy single URL — redirects (LegacyVideoReportRedirect)
    REPORT_GENERAL = '/report/general',
    REPORT_CLIENT = '/report/client',
    REPORT_BROADCASTERS_INNER = '/report/broadcasters-inner',
    REPORT_AUDIO = '/report/audioadreport',
    REPORTS = '/reports', // for post production
    REPORTS_ANNUAL = '/reports/annual',
    REPORTS_ACTIVITY_SUMMARY = '/reports/activity-summary', // post production only (spec 50)
    SETTINGS = '/settings',
    SETTINGS_USER = '/settings/user',
    SETTINGS_USERS = '/settings/users',
    SETTINGS_NOTIFICATIONS = '/settings/notifications',
    SETTINGS_PASSWORD = '/settings/password',
    SETTINGS_COMPANY = '/settings/company',
    SETTINGS_FTP = '/settings/ftpsettings',
    SETTINGS_RECIPIENTS = '/settings/additionalrecipients',
    ABOUT = '/about',
    FEATURES = '/features',
    PROCESS = '/process',
    CONTACT_US = '/contactus',
    LOGIN = '/account/login',
    REGISTRATION = '/account/registration/:token',
    FORGOT_PASSWORD = '/account/forgot-password',
    RESET_PASSWORD = '/account/reset-password',
    TERMS = '/terms',
    PRIVACY_POLICY = '/privacy-policy',
    TEST = '/test',
    SEARCH_RESULTS = '/searchresults',
    DEFAULT = '*',
};